export default "__VITE_ASSET__77$4Pz67__"